import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AlertService } from '@app/_services';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-expense-advance-search',
    templateUrl: './expense-advance-search.component.html',
    styleUrls: ['./expense-advance-search.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ExpenseAdvanceSearchComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private alertService: AlertService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title;
		this.advanceSearchData = data.advanceSearchData || {};
		this.properties = data.properties || [];
	}
	
	@Output() doSearchCB = new EventEmitter<any>();

	// forms
	AdvSearchForm: UntypedFormGroup;
	formTitle: String;
	advanceSearchData: any = {};
	properties: any[] = [];

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// If we were passed advanceSearchData, populate the form
		if (this.advanceSearchData && Object.keys(this.advanceSearchData).length > 0) {
			this.AdvSearchForm.patchValue(this.advanceSearchData);
		}
	}

	formSubmit() {
		try {
			this.AdvSearchForm.markAllAsTouched();
			if (this.AdvSearchForm.invalid) {
				return;
			}
			this.doSearchCB.emit(this.AdvSearchForm.value);
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.AdvSearchForm = this.formBuilder.group({
			shortTermRentalIds: [],
			taskName: [],
			expenseDate: [],
			amount: []
		});
	}
}
